module.exports = __webpack_public_path__ + "img/kiosk-place-de-la-cite-map.f9a08098.jpg";